import { createTheme } from "@mui/material";

const Theme = createTheme({
  palette: {
    primary: {
      // main: "#2E1834",
      main: "#7B408C",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: "#5C3069",
        },
      },
    },
  },
  typography: {
    fontFamily: "Lato",
    fontWeight: 400,
    h1: {
      fontWeight: 700,
      fontSize: "110px",
      color: "#fff",
      lineHeight: { lg: "98px", xs: "50px" },
    },
    h2: {
      fontWeight: 300,
      color: "#fff",
      fontSize: "20px",
      lineHeight: "30px",
    },
    h3: {
      fontWeight: 700,
      color: "#333333",
      fontSize: "64px",
    },

    h4: {
      fontWeight: 600,
      color: "#1a1a1a",
      fontSize: "20px",
    },
    h5: {
      fontWeight: 400,
      color: "#1a1a1a",
      fontSize: "14px",
      textTransform: "uppercase",
    },

    subtitle1: {
      color: "#151515",
      fontWeight: 600,
      fontSize: "16px",

      // lineHeight: "34px",
    },
    subtitle2: {
      color: "#1a1a1a",
      fontWeight: 500,
      fontSize: "30px",
      // lineHeight:'34px'
    },

    body1: {
      fontWeight: 400,
      fontSize: "12px",
      color: "#8B98A7",
    },
    body2: {
      color: "#151515",
      fontWeight: 500,
      fontSize: "12px",
    },
    caption: {
      fontWeight: 400,
      fontSize: "12px",
      color: "#1a1a1a",
    },
    button: {
      textTransform: "initial",
    },
  },
});

export default Theme;
